import _get from 'lodash/get'
import _isEmpty from 'lodash/isEmpty'
import { formatDate } from '@/js/utils/date.util'

export class UserRecord {
  constructor (record) {
    this._record = record

    this.general = {}
    this.address = {}
    this.documents = {}
    this.documentsArray = []
    this.documentsInfo = {}
    this.anchors = {}
    this.other = {}

    this.id = _get(record, 'id', '')
    if (this.id === 0) {
      this.id = _get(record, 'userId', '')
    }
    this.role = _get(record, 'role', '')
    this.email = _get(record, 'email', '')
    this.nftRole = _get(record, 'nftRole', '')
    this.affiliateId = _get(record, 'affiliateId', '')
    this.affiliate = _get(record, 'affiliate', '')
    this.affiliateLocked = _get(record, 'affiliateLocked', '')
    this.affiliateUpdatedAt = _get(record, 'affiliateUpdatedAt', '')
    this.affiliateCampaign = _get(record, 'affiliateCampaign', '')

    this.general.userId = _get(record, 'userId', '')
    this.general.firstName = _get(record, 'givenName', '')
    this.general.lastName = _get(record, 'familyName', '')
    this.general.fullName = _get(record, 'fullName', '')
    this.general.email = _get(record, 'email', '')
    this.general.isEmailVerified = _get(record, 'isEmailVerified', false)
    this.general.iban = _get(record, 'iban', '')
    this.general.birthDate = _get(record, 'birthDate', '')
    if (this.general.birthDate) {
      this.general.birthDate = formatDate(this.general.birthDate)
    }
    this.address.placeOfBirth = _get(record, 'placeOfBirth', {})
    this.address.nationalities = _get(record, 'nationalities', {})
    this.address.formattedAddress = _get(record, 'formattedAddress', '')
    this.address.structuredAddress = _get(record, 'structuredAddress', {})

    this.documentsInfo.isPhotoVerified = _get(record, 'photoVerified', false)
    this.documentsInfo.documentDetails = _get(record, 'documentDetails', {})

    this.other.rememberMeId = _get(record, 'rememberMeId', '')
    this.other.yesIdentifier = _get(record, 'yesIdentifier', '')

    this.documents.selfie = _get(record, 'selfie', '')
    this.documents.documentImages = _get(record, 'documentImages', '')

    this.documentsArray = _get(record, 'documents', '')

    this.anchors = _get(record, 'anchors', {})
  }

  get validFullName () {
    if (this.general.fullName) {
      return this.general.fullName
    } else {
      return `${this.general.firstName} ${this.general.lastName}`
    }
  }

  get validAddress () {
    if (this.address.formattedAddress) {
      return this.address.formattedAddress
    } else if (this.address.structuredAddress) {
      return Object.values(this.address.structuredAddress).join(', ')
    } else {
      return ''
    }
  }

  get isNotEmptyData () {
    return !_isEmpty(this._record)
  }

  get isNotEmptyDocImages () {
    return !_isEmpty(this.documents.documentImages)
  }

  get isNotEmptyDocInfo () {
    return !_isEmpty(this.documentsInfo.documentDetails)
  }

  get isNotEmptySelfie () {
    return !_isEmpty(this.documents.selfie)
  }

  get isNotEmptyDocumentsArray () {
    return !_isEmpty(this.documentsArray)
  }

  get isNotEmptyAnchors () {
    return !_isEmpty(this.anchors)
  }
}
